import 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    colors: {
      primary: string;
      primaryDark: string;
      primaryLight: string;
      accent: string;
      secondary: string;
      success: string;
      warning: string;
      error: string;
      info: string;
      white: string;
      gray50: string;
      gray100: string;
      gray200: string;
      gray300: string;
      gray400: string;
      gray500: string;
      gray600: string;
      gray700: string;
      gray800: string;
      gray900: string;
      background: string;
      surface: string;
      surfaceHover: string;
      textPrimary: string;
      textSecondary: string;
      textMuted: string;
    };
    spacing: {
      xs: string;
      sm: string;
      md: string;
      lg: string;
      xl: string;
      '2xl': string;
      '3xl': string;
    };
    borderRadius: {
      sm: string;
      md: string;
      lg: string;
      xl: string;
      full: string;
    };
    shadows: {
      sm: string;
      md: string;
      lg: string;
      xl: string;
    };
    breakpoints: {
      sm: string;
      md: string;
      lg: string;
      xl: string;
      '2xl': string;
    };
    typography: {
      fontFamily: {
        sans: string[];
        mono: string[];
      };
      fontSize: {
        xs: string;
        sm: string;
        base: string;
        lg: string;
        xl: string;
        '2xl': string;
        '3xl': string;
        '4xl': string;
      };
      fontWeight: {
        normal: string;
        medium: string;
        semibold: string;
        bold: string;
      };
    };
    transitions: {
      fast: string;
      normal: string;
      slow: string;
    };
  }
}

export const theme = {
  colors: {
    primary: '#008752',      // Verde oscuro Alianza Team (PANTONE 348C)
    primaryDark: '#006B41',
    primaryLight: '#7AC142', // Verde claro (PANTONE 368C)
    accent: '#FFC423',       // Amarillo (PANTONE 123C)
    secondary: '#53565A',    // Cool Gray 11 (paleta secundaria AT)
    success: '#00A499',      // PANTONE 3272C (paleta secundaria AT)
    warning: '#FFC423',
    error: '#C54644',        // PANTONE 2033C (paleta secundaria AT)
    info: '#004EA8',         // PANTONE 2145C (paleta secundaria AT)
    
    // Neutros (paleta secundaria AT)
    white: '#ffffff',
    gray50: '#f8fafc',
    gray100: '#f1f5f9',
    gray200: '#e2e8f0',
    gray300: '#D9D9D6',     // Cool Gray 1 AT
    gray400: '#A7A8AA',     // Cool Gray 6 AT
    gray500: '#53565A',     // Cool Gray 11 AT
    gray600: '#475569',
    gray700: '#2D2926',     // Black AT
    gray800: '#1e293b',
    gray900: '#0f172a',
    
    // Backgrounds
    background: '#f5faf6',   // Verde muy sutil como background
    surface: '#ffffff',
    surfaceHover: '#f1f5f9',
    
    // Text
    textPrimary: '#2D2926',  // Black AT
    textSecondary: '#53565A', // Cool Gray 11 AT
    textMuted: '#A7A8AA',    // Cool Gray 6 AT
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
  },
  
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    full: '9999px',
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },
  
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  typography: {
    fontFamily: {
      sans: ['Red Hat Display', 'Inter', 'system-ui', 'sans-serif'],
      mono: ['JetBrains Mono', 'monospace'],
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
    },
    fontWeight: {
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
    },
  },
  
  transitions: {
    fast: '0.15s ease-in-out',
    normal: '0.3s ease-in-out',
    slow: '0.5s ease-in-out',
  },
};

